import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { isEmpty } from "@/utils/validate"
import defAva from '@/assets/images/profile.jpg'
// // JavaScript 示例（其他语言可直接复用正则核心）
// const domainRegex =
//     /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

// // 测试示例
// function isLegalDomain(domain) {
//     // 先处理大小写（统一转小写）和前后空格
//     const cleanDomain = domain.trim().toLowerCase();
//     // 1. 校验总长度（不超过253字符）
//     if (cleanDomain.length > 253) return false;
//     // 2. 用正则匹配格式
//     return domainRegex.test(cleanDomain);
// }
const useUserStore = defineStore(
    'user',
    {
        state: () => ({
            token: getToken(),
            id: '',
            name: '',
            avatar: '',
            roles: [],
            rolesData: {},
            permissions: [],
            configurationData: {},
        }),
        actions: {
            // 登录
            login(userInfo) {
                const username = userInfo.username.trim()
                const password = userInfo.password
                const code = userInfo.code
                const uuid = userInfo.uuid
                // 可能存在其他环境签发的旧凭证，不应让它干扰新的登录流程。
                removeToken()
                this.token = ''
                this.roles = []
                this.permissions = []
                sessionStorage.removeItem('roles')
                sessionStorage.removeItem('deptId')
                sessionStorage.removeItem('userId')
                sessionStorage.removeItem('userName')
                sessionStorage.removeItem('deptData')
                return new Promise((resolve, reject) => {
                    login(username, password, code, uuid).then(res => {
                        let data = res.data
                        // console.log(data)
                        // if (isLegalDomain(window.location.host)) {

                            //获取私域id
                            let userSyxxId = data.syzcId;
                            if (userSyxxId && '' != userSyxxId) {
                                setToken(data.access_token);
                                // 
                                let url = `http://${window.location.host}/loginbmd?token=${data.access_token}`;
                                //跳转私域中转页面
                                // const url = `https://${userSyxxId}.hurryup.cc/loginbmd?token=${data.access_token}`;
                                window.location.href = url;
                                return;
                            }
                        // } 
                        // else {
                            setToken(data.access_token);
                            // const url = `http://${window.location.host}/loginbmd?token=${data.access_token}`
                            // window.location.href = url;
                            this.token = data.access_token
                            resolve()
                        // }
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 获取用户信息
            getInfo() {
                return new Promise((resolve, reject) => {
                    getInfo().then(res => {
                        const user = res.user
                        const avatar = (isEmpty(user.avatar)) ? null : user.avatar
                        if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                            this.roles = res.roles
                            this.permissions = res.permissions
                        } else {
                            this.roles = ['ROLE_DEFAULT']
                        }
                        this.id = user.userId
                        this.name = user.userName
                        this.avatar = avatar
                        this.rolesData = user
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            // 退出系统
            logOut() {
                return new Promise((resolve) => {
                    const clearLocalSession = () => {
                        this.token = ''
                        this.id = ''
                        this.name = ''
                        this.avatar = ''
                        this.roles = []
                        this.permissions = []
                        removeToken()
                        sessionStorage.removeItem('roles')
                        sessionStorage.removeItem('deptId')
                        sessionStorage.removeItem('userId')
                        sessionStorage.removeItem('userName')
                        sessionStorage.removeItem('deptData')
                        resolve()
                    }

                    // 本地凭证必须清理，不能依赖已失效 Token 的服务端退出请求成功。
                    logout(this.token).catch(() => undefined).finally(clearLocalSession)
                })
            },
            // 只清理本地会话，用于 Token 已无法被服务端验证的场景。
            resetToken() {
                this.token = ''
                this.id = ''
                this.name = ''
                this.avatar = ''
                this.roles = []
                this.permissions = []
                removeToken()
                sessionStorage.removeItem('roles')
                sessionStorage.removeItem('deptId')
                sessionStorage.removeItem('userId')
                sessionStorage.removeItem('userName')
                sessionStorage.removeItem('deptData')
                return Promise.resolve()
            },
            // 获取登录用户信息
            getInfos() {
                return new Promise((resolve, reject) => {
                    getInfo().then(res => {
                        const user = res.user || {}
                        const userRoles = Array.isArray(user.roles) ? user.roles : []
                        const roleKeys = Array.isArray(res.roles) ? res.roles : []
                        sessionStorage.setItem('deptId', user.deptId ?? '')
                        sessionStorage.setItem('userId', user.userId ?? '')
                        sessionStorage.setItem('userName', user.userName ?? '')
                        sessionStorage.setItem('deptData', JSON.stringify(userRoles[0] || null))
                        sessionStorage.setItem('roles', JSON.stringify(roleKeys))
                        const avatar = (isEmpty(user.avatar)) ? null : user.avatar
                        this.rolesData = user
                        this.roles = roleKeys.length > 0 ? roleKeys : ['ROLE_DEFAULT']
                        this.permissions = Array.isArray(res.permissions) ? res.permissions : []
                        this.id = user.userId
                        this.name = user.userName
                        this.avatar = avatar
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
        }
    })

export default useUserStore
